import { Pipe, PipeTransform } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'selectItemGroupDataPrepPipe'
})

export class SelectItemGroupDataPrepPipe implements PipeTransform {

  /**
   * Преобразует массив объектов, содержащий key и value в структуру SelectItemGroup для вывода в in-dropdown двухуровневых списков
   *
   * @param arr - Массив объектов, соответствующий массиву, возвращаемому KeyValuePipe (ключи key и value). Рекомендуется использовать после него
   * @param field_name - название ключа в option для вывода в список 2-го уровня
   * @returns массив объектов, отвечающий структуре [SelectItemGroup API](https://github.com/primefaces/primeng/blob/master/src/app/components/api/selectitemgroup.ts)
   */

  constructor(private translateService: TranslateService) {
  }

  newArray = [];

  emptyOption = {
    label: '',
    items: [
      {
        label: null,
        value: undefined
      }
    ]
  };
  emptyOption2 = {
    label: '',
    items: [null]
  };

  isEmptyOption( obj ) {
    if ( obj && obj.label === '' && obj.items && obj.items.value === null ) {
      return true;
    }
  }

  transform(arr: Array<any>, field_name: string, hasEmptyOption = false, hasEmptyOption2 = false, prefix?: string): any {
    if ( arr ) {
      for ( let i = 0; i < arr.length; i++ ) {
        if ( !this.isEmptyOption(arr[0]) && !arr[i].isPrepared) {
          // add label and items
          if ( arr[i].hasOwnProperty('key') && arr[i].hasOwnProperty('value') ) {
            arr[i].label = prefix ? prefix + arr[i].key : arr[i].key;
            arr[i].items = [];

            // add options to items
            for ( let j = 0; j < arr[i].value.length; j++ ) {
              arr[i].items[j] = {};
              Object.assign(arr[i].items[j], arr[i].value[j]);
              arr[i].items[j].label = arr[i].value[j][field_name];
              arr[i].items[j].value = {};
              Object.assign(arr[i].items[j].value, arr[i].value[j]);
            }
            arr[i].isPrepared = true;
          } else {
            throw new Error('Missing key and value keys. Use KeyValue pipe before.');
          }
        }
      }

      if ( hasEmptyOption && !this.isEmptyOption(arr[0])) {
        this.newArray = [this.emptyOption].concat(arr);
        return this.newArray;
      } else if ( hasEmptyOption2 && !this.isEmptyOption(arr[0])) {
        this.newArray = [this.emptyOption2].concat(arr);
        return this.newArray;

      } else {
        return arr;
      }
    }
  }
}
